<template>
  <content-box :width="wrapperWidth">
    <div v-if="state === 'register'" class="state__register">
      <i class="icon icon--coupon-ribbon"></i>
      <i class="icon icon--coupon-size70"></i>
      <p class="title">{{ $t('userInfo.coupon.register.title') }}</p>
      <p class="desc" v-html="$t('userInfo.coupon.register.desc')"></p>
      <form @submit.prevent="onSubmit">
        <ui-input-text
          :isInputAbove="false"
          :type="'text'"
          :id="'couponNumber'"
          :modelError="modelError"
          :placeholder="$t('common.placeHolder.coupon')"
          @onFocus="modelError = ''"
          @input="getValue">
          {{ $t('userInfo.coupon.register.form.label') }}
        </ui-input-text>
        <div class="button--wrap">
          <ui-button
            :buttonType="'reset'"
            @click="onCloseLayer">{{ $t('common.cancel') }}</ui-button>
          <ui-button
            class="btn__use"
            :buttonType="'submit'"
            :primary="true">{{ $t('common.use') }}</ui-button>
        </div>
      </form>
    </div>

    <div v-else-if="state === 'notFreePlan'" class="state__using-plan">
      <i class="icon icon--alert-size50"></i>
      <p class="title">{{ $t('userInfo.coupon.notFreePlan.title') }}</p>
      <p class="desc" v-html="$t('userInfo.coupon.notFreePlan.desc')"></p>
      <ui-button @click="onCloseLayer">{{ $t('common.confirm') }}</ui-button>
    </div>

    <div v-else class="state__complete">
      <i class="icon icon--check-green-size50"></i>
      <p class="desc">{{ $t('userInfo.coupon.complete') }}</p>
      <ui-button @click="onRegisterSuccess">{{ $t('common.confirm') }}</ui-button>
    </div>
  </content-box>
</template>

<script>
import ContentBox from '@/components/ui/ContentBox'
import UiButton from '@/components/ui/UiButton'
import UiInputText from '@/components/ui/UiInputText'
import { useCoupon } from '@/api/userPlan'

export default {
  components: {
    ContentBox,
    UiButton,
    UiInputText
  },
  data () {
    return {
      model: '',
      modelError: '',
      state: 'register'
    }
  },
  computed: {
    wrapperWidth () {
      return this.state === 'complete' ? '360px' : '430px'
    }
  },
  methods: {
    getValue (value) {
      this.model = value
    },
    onSubmit () {
      if (!this.model.length) {
        this.modelError = 'coupon.required'
        return false
      }
      useCoupon({ couponNumber: this.model }).then(() => {
        this.state = 'complete'
      }).catch(err => {
        if (err.message === 'Coupon not found') {
          this.modelError = 'coupon.notFound'
        } else if (err.message === 'Coupon not distributed') {
          this.modelError = 'coupon.notDistributed'
        } else if (err.message === 'Coupon expired') {
          this.modelError = 'coupon.hasExpired'
        } else if (err.message === 'Duplicate use' || err.message === 'Used coupon') {
          this.modelError = 'coupon.duplicatedUse'
        } else if (err.message === 'Not free plan') {
          this.state = 'notFreePlan'
        } else {
          this.modelError = 'coupon.notFound'
        }
      })
    },
    onCloseLayer () {
      this.$emit('closeLayer')
    },
    onRegisterSuccess () {
      this.onCloseLayer()
      window.location.reload(true)
    }
  }
}
</script>

<style lang="scss" scoped="scoped">
.content--wrap {
  text-align: center;
  padding-top: 40px;
  padding-bottom: 25px;

  .title {
    font-size: 20px;
    font-weight: bold;
    color: #444444;
  }
  .desc {
    font-size: 14px;
    line-height: 1.43;
    color: #2f2f2f;
  }

  .state__register {
    .icon--coupon-ribbon {
      position: absolute;
      top: 0;
      left: 0;
    }

    .title {
      margin-top: 5px;
      font-size: 20px;
      font-weight: bold;
      color: $brandColor;
    }

    .desc {
      margin-top: 12px;
    }

    form {
      margin: 40px auto 0;
      width: 290px;
    }

    .button--wrap {
      margin-top: 40px;
      .btn__use {
        margin-left: 5px;
      }
    }
  }

  .state__using-plan {
    .title {
      margin-top: 15px;
    }
    .desc {
      margin-top: 12px;
    }
    /deep/ .ui-btn {
      margin-top: 50px;
    }
  }

  .state__warning {
    padding-left: 30px;
    padding-right: 30px;
    .title {
      margin-top: 15px;
    }
    .desc {
      margin-top: 12px;
    }
    .checkbox--wrap {
      position: relative;
      width: 100%;
      text-align: center;
      border-top: 1px solid #d8d8d8;
      margin-top: 25px;
      padding-top: 20px;

      /deep/ .text {
        font-size: 13px;
        color: #666666;
      }
    }
    .validation-text {
      @include validErrorText;
      position: absolute;
      left: 68px;
      bottom: -20px;
    }
    .button--wrap {
      margin-top: 25px;
      .btn__confirm {
        margin-left: 5px;
      }
    }
  }

  .state__complete {
    .desc {
      margin-top: 20px;
    }
    /deep/ .ui-btn {
      margin-top: 50px;
    }
  }
}
</style>
